import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../../assets/cashlet.svg';
import Sidebar from '../Sidebar/Sidebar';
import '../../assets/css/common.css';

export default function Navbar(props) {
  const [navbarOpen, setNavbarOpen] = useState(false);

  return (
    <>
      <nav className="top-0 fixed z-50 w-full flex flex-wrap items-center justify-between pl-4 py-1 md:py-3 navbar-expand-lg bg-white">
        <div className="w-full lg:container px-0 mx-auto flex flex-wrap items-center justify-between">
          <div className="w-full relative flex justify-between lg:w-auto lg:static lg:block lg:justify-start">
            <NavLink
              to="/"
              className="text-gray-800 font-site leading-relaxed inline-flex items-center mr-4 py-2 whitespace-no-wrap space-x-4"
            >
              <img className="w-auto" src={logo} alt="Logo" />
            </NavLink>
            <button
              className="cursor-pointer text-xl leading-none px-3 py-1 border border-solid border-transparent rounded bg-transparent block lg:hidden outline-none focus:outline-none"
              type="button"
              onClick={() => setNavbarOpen(!navbarOpen)}
            >
              {navbarOpen ? (
                <svg
                  className="h-10 w-10  "
                  fill="none"
                  // viewBox="0 0 24 24"
                  stroke="currentColor">
                  <path transform="translate(-0, -0)" className="close-x" strokeWidth="2" d="M 10,10 L 30,30 M 30,10 L 10,30" />
                </svg>
              ) : (
                <svg
                  className="h-10 w-10 "
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  aria-hidden="true"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1" d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
          <div className="lg:flex flex-grow items-center bg-white lg:bg-transparent lg:shadow-none hidden ">
            <ul className="flex flex-col lg:flex-row list-none">
              {/* <li className="flex items-center">
                <NavLink
                  exact
                  className="hover:text-gray-600 px-3 lg:px-6 py-4 lg:py-2 flex items-center text-center text-base font-semibold"
                  to="/"
                  activeClassName="nav-item-active"
                  style={{
                    color: '#5E6166'
                  }}
                >
                  Home
                </NavLink>
              </li> */}
              <li className="flex items-center">
                <NavLink
                  className="hover:text-gray-600 px-3 lg:px-6 py-4 lg:py-2 flex items-center text-center text-base font-semibold"
                  to="/about-us"
                  activeClassName="nav-item-active"
                  exact
                  style={{
                    color: '#5E6166'
                  }}
                >
                  About us
                </NavLink>
              </li>
              <li className="flex items-center">
                <NavLink
                  className="hover:text-gray-600 px-3 lg:px-6 py-4 lg:py-2 flex items-center text-center text-base font-semibold"
                  to="/FAQ"
                  activeClassName="nav-item-active"
                  exact
                  style={{
                    color: '#5E6166'
                  }}
                >
                  FAQ
                </NavLink>
              </li>
              <li className="flex items-center">
                <NavLink
                  className="hover:text-gray-600 px-3 lg:px-6 py-4 lg:py-2 flex items-center text-center text-base font-semibold"
                  to="/security"
                  activeClassName="nav-item-active"
                  exact
                  style={{
                    color: '#5E6166'
                  }}
                >
                  Security
                </NavLink>
              </li>
              <li className="flex items-center">
                <NavLink
                  activeClassName="nav-item-active"
                  style={{
                    color: '#5E6166'
                  }}
                  className="hover:text-gray-600 px-3 lg:px-6 py-4 lg:py-2 flex items-center text-center text-base font-semibold"
                  to="/blog"
                >
                  Blog
                </NavLink>
              </li>
            </ul>
          </div>
          {/* <div>
            <button type="button" className="hidden lg:block btn-primary text-xl font-semibold">Create an account</button>
          </div> */}
          <Sidebar setNavbarOpen={setNavbarOpen} navbarOpen={navbarOpen} />
        </div>
      </nav>
    </>
  );
}
